type PurchasedSeries =
  | {
      documentId: string;
    }[]
  | null
  | undefined;
export const hasCustomerSeriesAccess = (
  seriesDocumentId: string,
  purchasedSeries: PurchasedSeries,
  isSubscriber: boolean,
) => {
  if (isSubscriber) return true;
  return !!purchasedSeries?.find((s) => s?.documentId === seriesDocumentId);
};
